var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-container"},[_c('a-tabs',{attrs:{"type":"card"},on:{"change":function($event){return _vm.$emit('change', $event)}}},_vm._l((_vm.tabs),function(item,idx){return _c('a-tab-pane',{key:idx,class:`${item}-wrapper`,attrs:{"tab":_vm.getTabName(item),"disabled":_vm.disabledTabs.includes(item)}},[_vm._t(item)],2)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }